/** @file Angle helpers in degrees: wrapping to [-180, 180) and shortest signed difference. */

export const angle = {
  /** Wraps degrees into [-180, 180). 180 maps to -180. */
  wrap180(deg: number): number {
    return ((((deg + 180) % 360) + 360) % 360) - 180;
  },
  /** Signed shortest rotation from `from` to `to`, in [-180, 180). */
  shortest(from: number, to: number): number {
    return angle.wrap180(to - from);
  },
  /** Degrees to radians. */
  degToRad(deg: number): number {
    return (deg * Math.PI) / 180;
  },
  /** Radians to degrees. */
  radToDeg(rad: number): number {
    return (rad * 180) / Math.PI;
  },
};
